import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';
import { ConsultaPlacaDisponivelRequest } from 'pages/DetranCrv/SolicitarDocumentos/EscolherPlaca/ResultadoConsulta/form';
import { Types } from './types';
import {
	consultaPlacaDisponivelSuccess,
	consultaPlacaDisponivelFailure,
} from './actions';

function* consultaPlacaDisponivelRequest(request: {
	type: string;
	payload: ConsultaPlacaDisponivelRequest;
}) {
	const { payload } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`servicos/${CHANNEL}/consultar-placa-disponivel`,
		payload,
	);
	if (response.status === 200 || response.status === 201) {
		yield put(consultaPlacaDisponivelSuccess(response));
	} else if (response.error) {
		yield put(consultaPlacaDisponivelFailure(response.message));
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_PLACA_DISPONIVEL_REQUEST,
		consultaPlacaDisponivelRequest,
	),
]);
